export const userHeaderStyle = {
	header: {
		backgroundColor: 'var(--default-white)',
		position: 'sticky',
		top: 0,
		zIndex: 100,
		boxShadow: 'var(--box-shadow--1)',
		flexShrink: 0,
	},
	panel: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		margin: '0 auto',
		maxWidth: '1200px',
		minHeight: '80px',
		padding: '0 15px',

		'@media (max-width: 1199.98px)': {
			minHeight: '104px',
			padding: '16px 40px',
			alignItems: 'flex-end',
		},

		'@media (max-width: 767.98px)': {
			width: '100%',
			display: 'flex',
			justifyContent: 'space-between',

			'@media (max-width: 639.98px)': {
				padding: '16px 20px',
			},
		},
	},
	loginButton: {
		maxWidth: '175px',
		width: '100%',
	},
	content: {
		display: 'flex',
		alignItems: 'center',
		gap: '24px',

		'@media (max-width: 767.98px)': {
			flexDirection: 'row-reverse',
		},
	},
	button: {
		background: 'var(--background-grey-op-50-1)',
	},
	actions: {
		display: 'flex',
		gap: '24px',
		alignItems: 'center',

		'@media (max-width: 767.98px)': {
			justifyContent: 'space-between',
			width: '100%',
		},
	},

	btnWrapper: {
		height: '44px',

		'@media (max-width: 767.98px)': {
			display: 'none',
		},
	},
};
